var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_vm._v(" Offer or Ask for "),_c('MyOffers'),_c('OtherOffers')],1)}
var staticRenderFns = []

export { render, staticRenderFns }